<template>
  <v-input
    ref="input"
    :rules="rules"
    :disabled="disabled"
    :readonly="readonly"
    :error-messages="errorMessages"
    :label="label"
    :class="`text-area ${required ? '--required' : ''} ${
      disabled ? 'input--disabled' : ''
    } `"
    v-model="value"
    light
  >
    <textarea
      :autocomplete="type === 'password' ? 'off' : 'on'"
      :type="type"
      :value="value"
      :rows="rows"
      :cols="cols"
      @input="
        (e) => {
          $emit('input', e.target.value);
        }
      "
      @change="
        (e) => {
          $emit('change', e.target.value);
        }
      "
      @blur="
        (e) => {
          $emit('blur', e.target.value);
        }
      "
    />
  </v-input>
</template>

<script>
export default {
  name: 'text-area',
  props: {
    value: { required: true },
    rules: Array,
    disabled: Boolean,
    readonly: Boolean,
    errorMessages: String,
    label: String,
    required: Boolean,
    type: String,
    rows: String,
    cols: String,
  },
};
</script>

<style lang="scss">
.text-area {
  margin-top: 21px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  .v-label {
    position: absolute !important;
    top: -25px;
    font-size: 14px;
  }

  textarea {
    white-space: pre;
    resize: auto;
    padding: 0.5em;
    border: 1px solid #dcdcdc;
    border-radius: 3px;
    transition: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/TextArea.vue